export class NoStrategyToExecuteError extends Error {
  constructor(message) {
    super(message);
    this.name = 'NoStrategyToExecuteError';
  }
}
